import { isQueryParamFlagsTrue } from '../utils/isQueryParamFlagsTrue';
import { QueryParams } from '../constants/QueryParams';
import { createStore } from 'reusable';
import { useQueryParams } from './useQueryParams';
import { getIsLoggedInByCookie } from '../utils/getIsLoggedInByCookie';

export const useReturnedFromLogin = createStore(() => {
  const { getParam } = useQueryParams();
  const isUserLoggedIn = getIsLoggedInByCookie();
  const returnedFromLoginPageParam = isQueryParamFlagsTrue(
    getParam(QueryParams.RETURNED_FROM_LOGIN_PAGE),
  );
  const hasTemplateId =
    getParam(QueryParams.ID) || getParam(QueryParams.TEMPLATE_ID);

  const returnedFromLogin =
    hasTemplateId && returnedFromLoginPageParam && isUserLoggedIn;

  return { returnedFromLogin };
});
